import React from "react";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Chip from "@material-ui/core/Chip";

const COLORS = {
  surface: "#232a33",
  border: "rgba(255,255,255,0.08)",
  textPrimary: "#edeff2",
  textSecondary: "#8d99a8",
  accent: "#2f8fff",
  accentSoft: "rgba(47,143,255,0.14)",
};

export default function AssistantOptionsCard({ field, prompt, options, onSelect }) {
  if (!options || options.length === 0) return null;

  return (
    <Card
      style={{
        margin: "4px 0",
        backgroundColor: COLORS.surface,
        border: `1px solid ${COLORS.border}`,
        boxShadow: "none",
      }}
    >
      <CardContent>
        {prompt && (
          <div style={{ color: COLORS.textPrimary, fontSize: 14, fontWeight: 600, marginBottom: 10 }}>
            {prompt}
          </div>
        )}
        <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
          {options.map((option) => (
            <Chip
              key={`${field}-${option.value}`}
              label={option.label}
              clickable
              size="small"
              onClick={() => onSelect(option)}
              style={{
                backgroundColor: "transparent",
                border: `1px solid ${COLORS.border}`,
                color: COLORS.textPrimary,
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = COLORS.accentSoft;
                e.currentTarget.style.borderColor = COLORS.accent;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "transparent";
                e.currentTarget.style.borderColor = COLORS.border;
              }}
            />
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
